module.exports = __webpack_public_path__ + "img/control.a4085ab.svg";